export const SmileyFace = ({ width = 51, height = 51, stroke = '#1AFF06' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 51 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="25.5" cy="26" r="20.5" stroke={stroke} strokeWidth="3" />
      <path
        d="M15.5 30C15.5 30 19.3551 34 25.6884 34C32.0217 34 34.5 30 34.5 30"
        stroke={stroke}
        strokeWidth="3"
        strokeLinejoin="round"
      />
      <circle cx="32.4078" cy="19.6046" r="2.30233" fill={stroke} />
      <circle cx="18.5933" cy="19.6046" r="2.30233" fill={stroke} />
    </svg>
  );
};
